// const URL = process.env.REACT_APP_SERVER_URL;

const URL = "http://localhost:5000";

export default URL;
